"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailDesign = void 0;

var EmailDesign =
/** @class */
function () {
  function EmailDesign() {}

  EmailDesign.prototype.EmailDesignLayoutType = function () {
    return [{
      slug: 'blank',
      name: 'Blank',
      description: null,
      isBlank: true,
      isAltEmailLayout: false
    }, {
      slug: 'alt-email-layout',
      name: 'Alt Email Layout',
      description: null,
      isBlank: false,
      isAltEmailLayout: true
    }];
  };

  return EmailDesign;
}();

exports.EmailDesign = EmailDesign;